import { useServices } from 'containers/services';
import { useQuery, type UseQueryOptions, type UseQueryResult } from 'react-query';
import { QUERY_KEYS } from 'utils/queryKeys';
import type { SerializedMeterModel } from '@enmon/commons/lib/tools';
import type { GetOneMeterModelArg, GetOneMeterModelResult } from '../../../lib/services';

export const useOneMeterModel = (
  { modelId, populate }: Pick<GetOneMeterModelArg, 'modelId' | 'populate'>,
  options?: UseQueryOptions<SerializedMeterModel, Error>,
): UseQueryResult<GetOneMeterModelResult> => {
  const { meterModelsApiClient } = useServices();

  return useQuery({
    queryKey: QUERY_KEYS.meterModels.one(modelId),
    queryFn: async ({ signal }) => await meterModelsApiClient.findOne({ modelId, populate, signal }),
    ...options,
  });
};
